const averageRating = (ratings: any) => {
  const totalRatings = ratings?.length;
  const sumOfRatings = ratings?.reduce((sum: number, rating: any) => sum + rating?.rating, 0);
  const averageRating = totalRatings > 0 ? sumOfRatings / totalRatings : 0;
  const ratingText = totalRatings > 0
  ? `${averageRating.toFixed(1)} (${totalRatings} reviews) `
  : 'No reviews (yet)';
  return ratingText
}

const trimAddress = (address: string) => {
  const addressParts = address?.split(',').map(part => part.trim());
  const result = addressParts?.slice(-2).join(', ');
  return result
}

function generateSchedule(daysCount: number, schedulesAvailable: any[]) {
  const today = new Date();
  const output = [];

  for (let i = 0; i <= daysCount; i++) {
    const currentDate = new Date(today);
    currentDate.setDate(today.getDate() + i);

    const dayString = currentDate.toISOString()?.split('T')[0];

    const scheduleIndex = currentDate.getDay();
    const schedule = schedulesAvailable[scheduleIndex];

    const modifiedSchedule = {
      "day": schedule["day"],
      "startTime": schedule["startTime"],
      "endTime": schedule["endTime"],
      "slots": schedule["slots"],
      "dayString": dayString,
    };

    output.push(modifiedSchedule);
  }

  return output;
}

function formatDate(inputDateString: string) {
  // Create a Date object from the input string
  const inputDate = new Date(inputDateString);

  // Check if the date is valid
  if (isNaN(inputDate)) {
    return "Invalid date";
  }

  // Format the date to "MMM DD" (e.g., "Feb 24")
  const formattedDate = inputDate.toLocaleString('en-US', { month: 'short', day: 'numeric', weekday: 'short' });

  return formattedDate;
}


export {
  averageRating,
  trimAddress,
  generateSchedule,
  formatDate
}